import Vue from "vue";
import Vuex from "vuex";
import Cookies from "js-cookie";
import auth, { cookieExpired, cookiePath } from "@/services/auth";
import mantenedor from "@/services/mantenedor";
import router from "@/router";
// import router from "@/router";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    rutaActual: "",
    snackbar: {
      mostrar: false,
      mensaje: "",
      color: "success",
      icon: ""
    },
    drawer: true,
    expireTimeout: null,
    dialogoCampania: false,
    dialogoMora: false,
    dialogoMoraAvalado: false,
    sideBarMenuBits: {
      b_creditos_firmar: false,
      b_pago: true,
      b_mayor: true
    },
    parametros: {
      mantencion: false,
      simuladorCredito: true,
      pago: true,
      creditos: false,
      certificado: true
    },
    publicidadesDialogo: null,
    publicidadesSlider: null,
    dialogoPublicidades: false,
    loadingState: true
  },
  getters: {
    drawer: (state) => {
      return state.drawer;
    },
    validBits: (state) => {
      let currentBits = state.sideBarMenuBits;

      let asArray = Object.entries(currentBits);
      let filtered = asArray.filter((item) => item[1]);
      let justValid = filtered.map((item) => item[0]);

      return (requiredBits) => {
        return requiredBits.every((element) => {
          return justValid.includes(element);
        });
      };
    }
  },
  mutations: {
    cambiarRuta(state, ruta) {
      state.rutaActual = ruta;
    },
    setTimeout(state) {
      let current = new Date().getTime();
      let expires = new Date(Cookies.get(cookieExpired));
      let remaining = expires.getTime() - current;

      if (process.env.NODE_ENV === "development") {
        console.log(
          "Expiración: ",
          expires.getHours() +
            ":" +
            (expires.getMinutes() < 10
              ? "0" + expires.getMinutes()
              : expires.getMinutes())
        );
      }
      if (!state.expireTimeout)
        state.expireTimeout = setTimeout(function () {
          // let redirect = router.currentRoute.meta?.requiresAuth ? true : false;
          // if (redirect) router.push("/login");
          alert(
            "Su sesión ha expirado, si quiere seguir utilizando el portal ingrese nuevamente"
          );
          auth.cerrarSesion(/*redirect*/);
        }, remaining);
    },
    closeTimeout(state) {
      clearTimeout(state.expireTimeout);
      state.expireTimeout = null;
    },
    SET_SNACKBAR(state, payload) {
      state.snackbar = payload;
    },
    CLOSE_SNACKBAR(state) {
      state.snackbar.mostrar = false;
    },
    SET_DRAWER(state, value) {
      state.drawer = value;
    },
    SET_DIALOGO(state, value) {
      state.dialogoCampania = value;
    },
    SET_DIALOGO_MORA(state, value) {
      state.dialogoMora = value;
    },
    SET_DIALOGO_MORA_AVALADO(state, value) {
      state.dialogoMoraAvalado = value;
    },
    SET_BITS(state, value) {
      state.sideBarMenuBits = value;
    },
    SET_PUBLICIDADES(state, value) {
      if (value.dialog) state.publicidadesDialogo = value.data;
      else state.publicidadesSlider = value.data;
    },
    SET_DIALOGO_PUBLICIDADES(state, value) {
      state.dialogoPublicidades = value;
    },
    CLEAN_PUBLICIDADES(state) {
      state.publicidadesDialogo = null;
      state.publicidadesSlider = null;
    },
    SET_PARAMETROS(state, value) {
      state.parametros = value;
    },
    SET_LOADING_STATE(state, value) {
      state.loadingState = value;
    }
  },
  actions: {
    mostrarAlerta({ commit }, payload) {
      if (payload.color === "success") {
        payload.icon = "mdi-check-circle-outline";
      } else if (payload.color === "warning") {
        payload.icon = "mdi-alert-outline";
      } else if (payload.color === "error") {
        payload.icon = "mdi-alert-octagon-outline";
      } else if (payload.color === "info") {
        payload.icon = "alert-circle-outline";
      }

      commit("SET_SNACKBAR", {
        mostrar: true,
        color: payload.color,
        mensaje: payload.mensaje,
        icon: payload.icon
      });
    },
    cerrarAlerta({ commit }) {
      commit("CLOSE_SNACKBAR");
    },

    switchDrawer({ commit }, value) {
      commit("SET_DRAWER", value);
    },
    mostrarDialogo({ commit }, value) {
      commit("SET_DIALOGO", value);
    },
    mostrarDialogoMora({ commit }, payload) {
      let { val, type } = payload;
      if (type == 1) commit("SET_DIALOGO_MORA", val);
      else if (type == 2) commit("SET_DIALOGO_MORA_AVALADO", val);
    },
    mostrarDialogoPublicidad({ commit }, value) {
      commit("SET_DIALOGO_PUBLICIDADES", value);
    },
    updateBits({ commit }) {
      let updatedUser = auth.getUserLogged();
      commit("SET_BITS", {
        b_creditos_firmar: updatedUser.b_creditos_firmar,
        b_pago: updatedUser.b_pago,
        b_mayor: updatedUser.b_mayor
      });
    },
    limpiarPublicidades({ commit }) {
      commit("SET_DIALOGO_PUBLICIDADES", false);
      commit("CLEAN_PUBLICIDADES");
    },
    async setPublicidades({ commit }, data) {
      await mantenedor
        .obtenerPublicidades(data.user, data.mostrar)
        .then((res) => {
          commit("SET_PUBLICIDADES", { data: res.data, dialog: data.mostrar });
          if (data.mostrar && res.data.length > 0)
            commit("SET_DIALOGO_PUBLICIDADES", true);
        })
        .catch((error) => console.error(error));
    },
    async setParametros({ commit }) {
      commit("SET_LOADING_STATE", true);
      await mantenedor
        .obtenerParametros()
        .then((res) => {
          commit("SET_PARAMETROS", res.data);
        })
        .catch((error) => console.error(error));
      commit("SET_LOADING_STATE", false);
    },
    async initData({ dispatch, commit }) {
      try {
        let promises = [dispatch("setParametros")];
        // let promises = [];
        if (auth.isAuthenticated()) {
          commit("setTimeout");
          promises.push(dispatch("updateBits"));
        }
        await Promise.all(promises);
      } catch (error) {
        commit("closeTimeout");
        Cookies.remove(cookieExpired);
        Cookies.remove(cookiePath);
        await Vue.nextTick(); // Ensure the DOM is updated before navigating
        await router.push("/login");
      }
    }
  },
  modules: {}
});
